import { render, staticRenderFns } from "./LinkCompanySociedadDialog.vue?vue&type=template&id=d7354510&scoped=true"
import script from "./LinkCompanySociedadDialog.vue?vue&type=script&lang=js"
export * from "./LinkCompanySociedadDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7354510",
  null
  
)

export default component.exports